<template>
  <div class="container container--fluid">
    <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
      <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
      <v-btn dark text @click="snackbar = false">Close</v-btn>
    </v-snackbar>
    <div class="d-flex justify-end">
      <v-btn 
        color="brand onBrand--text"
        dark
        small
        style="border-radius:8px;margin-top:-15px"
        @click="videoDialog = true"
      >
      <v-icon left>mdi-youtube</v-icon>
      Watch Tutorial
      </v-btn>
      </div>

    <v-form id="leave_form">
      <v-row>
        <v-col>
          <v-card class="box">
            <v-toolbar dense class="toolbar" flat color="white">
              <v-toolbar-title>Apply Leave Of My Kids</v-toolbar-title>
              <v-divider class="mx-4" inset vertical></v-divider>
              <v-spacer></v-spacer>
            </v-toolbar>

            <v-simple-table class="elevation-1" dense>
              <template v-slot:default>
                <thead>
                  <tr>
                    <th>
                      <v-checkbox v-model="selectAll" @click="select"></v-checkbox>
                    </th>
                    <th>Student Name</th>
                    <th>Roll No</th>
                    <th>Registration No</th>
                    <th>Standard</th>
                    <th>Division</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="i in childrenList" :key="i.Registration_No">
                    <td>
                      <v-checkbox :value="i.Registration_No" v-model="selected"></v-checkbox>
                    </td>
                    <td>{{ i.Student_Name }}</td>
                    <td>{{ i.Roll_No }}</td>
                    <td>{{ i.Registration_No }}</td>
                    <td>{{ i.Standard }}</td>
                    <td>{{ i.Division }}</td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>

            <v-row class="justify-center">
              <v-menu
                ref="menu1"
                v-model="menu1"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
                max-width="290px"
                min-width="290px"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-col cols="12" sm="6" md="4">
                    <v-text-field
                      v-model="start_date"
                      v-bind="attrs"
                      @blur="sdate = parseDate(start_date)"
                      persistent-hint
                      v-on="on"
                      label="Start Date"
                      prepend-icon="event"
                    ></v-text-field>
                    (Inclusive Date)
                  </v-col>
                </template>
                <v-date-picker v-model="sdate" no-title @input="menu1 = false"></v-date-picker>
              </v-menu>

              <v-menu
                ref="menu2"
                v-model="menu2"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
                max-width="290px"
                min-width="290px"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-col cols="12" sm="6" md="4">
                    <v-text-field
                      v-bind="attrs"
                      v-model="end_date"
                      @blur="edate = parseDate(end_date)"
                      persistent-hint
                      v-on="on"
                      label="End Date"
                      prepend-icon="event"
                    ></v-text-field>
                    (Inclusive Date)
                  </v-col>
                </template>
                <v-date-picker v-model="edate" no-title @input="menu2 = false"></v-date-picker>
              </v-menu>
            </v-row>

            <v-row class="justify-center">
              <v-col cols="10" sm="10" md="10">
                <v-textarea
                  v-model="leaveReason"
                  label="Reason for Leave"
                  persistent-hint
                  outlined
                ></v-textarea>
              </v-col>
            </v-row>

            <v-row class="justify-center">
              <v-col cols="10" sm="10" md="10">
                <p><b>Attachment If Any</b></p>
                <v-file-input v-model="attachment"></v-file-input>
              </v-col>
            </v-row>

            <v-card-actions class="justify-center">
              <v-btn
                class="md-2 button"
                color="primary"
                @click="submit"
                :disabled="!start_date || !end_date || !selected.length"
              >
                Apply Leave
              </v-btn>
            </v-card-actions>

            <br />

            <v-col>
              <v-card class="box">
                <v-toolbar dense class="toolbar" flat color="white">
                  <v-toolbar-title>Applied Leaves</v-toolbar-title>
                  <v-divider class="mx-4" inset vertical></v-divider>
                  <v-spacer></v-spacer>
                </v-toolbar>

                <v-data-table
                  v-model="selectedTasks"
                  :headers="leaveApplicationHeaders"
                  :items="leaveApplicationList"
                  :search="search"
                  class="elevation-1"
                >
                  <template v-slot:[`item.attachments`]="{ item }">
                    <span v-if="item.attachments">
                      <a :href="basepath + item.attachments" target="_blank">Attachment</a>
                    </span>
                    <span v-else>-</span>
                  </template>

                  <!-- Edit Button (Commented Out) -->
                  <!--
                  <template v-slot:[`item.edit`]="{ item }">
                    <v-avatar size="25" class="edit-avatar">
                      <v-icon color="primary" @click="editItem(item)" title="Edit Application">
                        mdi-file-document-edit
                      </v-icon>
                    </v-avatar>
                  </template>
                  -->

                  <!-- Delete Button -->
                  <template v-slot:[`item.delete`]="{ item }">
                    <v-avatar size="25" class="delete-avatar">
                      <v-icon color="red" @click="openDeleteDialog(item)" title="Delete Application">
                        mdi-delete
                      </v-icon>
                    </v-avatar>
                  </template>
                </v-data-table>
              </v-card>
            </v-col>
          </v-card>
        </v-col>
      </v-row>
    </v-form>

    <!-- Delete Confirmation Dialog -->
    <v-dialog v-model="deleteDialog" max-width="500px">
      <v-card>
        <v-card-title class="headline">Confirm Delete</v-card-title>
        <v-card-text>
          Are you sure you want to delete this leave application for
          <strong>{{ deleteItem ? deleteItem.Children_Name : '' }}</strong>?
          <br />
          <small>From: {{ deleteItem ? deleteItem.From : '' }} | To: {{ deleteItem ? deleteItem.To : '' }}</small>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="deleteDialog = false">Cancel</v-btn>
          <v-btn color="red darken-1" text @click="confirmDelete" :loading="deleting">Delete</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Edit Dialog (Commented Out) -->
    <!--
    <v-dialog v-model="dialog_edit" max-width="1100px" v-if="dialog_edit">
      <v-card class="card-container">
        <v-toolbar class="toolbar" flat dense>
          <v-toolbar-title><strong>Edit Leave</strong></v-toolbar-title>
        </v-toolbar>
        <v-card-text>
          <v-row justify="center" dense>
            <v-col cols="12" sm="3">
              <p><b>From Date</b></p>
              <input type="date" v-model="from_date_edit" />
            </v-col>
            <v-col cols="12" sm="3">
              <p><b>To Date</b></p>
              <input type="date" v-model="to_date_edit" />
            </v-col>
            <v-col cols="12" sm="3">
              <p><b>Reason</b></p>
              <v-text-field outlined dense v-model="reason_edit"></v-text-field>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions class="justify-center">
          <v-btn class="dialog-btn" @click="dialog_edit = false">Close</v-btn>
          <v-btn class="primary" @click="updateLeaveDetails()" :loading="loader">Save</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    -->

    <v-overlay :value="overlay">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
    <v-dialog v-model="videoDialog" max-width="1000px">
      <v-card>
        <v-card-title class="d-flex justify-space-between align-center grey lighten-4">
          <span style="color:black">Apply for Leave Tutorial</span>
          <v-btn icon @click="videoDialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text class="pa-0">
          <v-responsive :aspect-ratio="16/9">
           <iframe
              v-if="videoDialog"
              width="100%"
              height="100%"
              src="https://www.youtube.com/embed/jp9PLcgFT68?si=DiRpz3oI16h-eNQj"
              title="YouTube video player"
              frameborder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowfullscreen
            ></iframe>
          </v-responsive>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import axios from "axios";

export default {
  data: () => ({
    attachment: null,
    leaveApplicationHeaders: [
      { text: "Child Name", value: "Children_Name", sortable: true },
      { text: "Standard", value: "Standard", sortable: true },
      { text: "Division", value: "division", sortable: true },
      { text: "Application Date", value: "Application_Date", sortable: true },
      { text: "From", value: "From", sortable: true },
      { text: "To", value: "To", sortable: true },
      { text: "Reason", value: "Reason", sortable: true },
      { text: "Attachment", value: "attachments", sortable: false },
      // { text: "Edit", value: "edit", sortable: false }, // Commented
      { text: "Delete", value: "delete", sortable: false } // Added
    ],
    selected: [],
    selectAll: false,
    singleSelect: false,
    videoDialog:false,
    menu1: false,
    menu2: false,
    color: "",
    snackbar: false,
    selectedTasks: [],
    leaveApplicationList: [],
    childrenList: [],
    search: "",
    start_date: "",
    end_date: "",
    sdate: new Date().toISOString().substr(0, 10),
    edate: new Date().toISOString().substr(0, 10),
    snackbar_msg: "",
    leaveReason: "",
    overlay: false,

    // Delete Dialog
    deleteDialog: false,
    deleting: false,
    deleteItem: null,

    // Edit (Commented)
    // dialog_edit: false,
    // from_date_edit: "",
    // to_date_edit: "",
    // reason_edit: "",
    // application_date_edit: "",
    // edit_item: "",

    basepath: null
  }),

  watch: {
    sdate(val) {
      this.start_date = this.formatDate(val);
    },
    edate(val) {
      this.end_date = this.formatDate(val);
    }
  },

  mounted() {
    this.onLoad();
    this.basepath = localStorage.getItem("awspath");
  },

  methods: {
    // === DELETE METHODS ===
    openDeleteDialog(item) {
      this.deleteItem = item;
      this.deleteDialog = true;
    },

    confirmDelete() {
      this.deleting = true;
      axios
        .post("/Parent/deleteLeaveRequest", { id: this.deleteItem.id })
        .then((res) => {
          if (res.data.status === "SUCCESS" || res.data.flag === "YES") {
            this.showSnackbar("#4caf50", "Leave deleted successfully!");
            this.onLoad(); // Refresh list
          } else {
            this.showSnackbar("#b71c1c", res.data.msg || "Failed to delete leave.");
          }
        })
        .catch((err) => {
          console.error(err);
          this.showSnackbar("#b71c1c", "Error deleting leave.");
        })
        .finally(() => {
          this.deleting = false;
          this.deleteDialog = false;
          this.deleteItem = null;
        });
    },

    // === EDIT METHODS (COMMENTED OUT) ===
    /*
    editItem(item) {
      this.dialog_edit = true;
      this.edit_item = item.id;
      this.from_date_edit = item.fromdate_edit;
      this.to_date_edit = item.todate_edit;
      this.application_date_edit = item.application_date_edit;
      this.reason_edit = item.Reason;
    },
    updateLeaveDetails() {
      const formData = {
        edit_item: this.edit_item,
        from_date_edit: this.from_date_edit,
        to_date_edit: this.to_date_edit,
        reason_edit: this.reason_edit,
        application_date_edit: this.application_date_edit,
      };
      this.loader = true;
      axios
        .post("/Parent/updateLeaveDetails", formData)
        .then((res) => {
          if (res.data.flag == "YES") {
            this.showSnackbar("#4caf50", "Leave Updated Successfully...!");
            this.dialog_edit = false;
            this.onLoad();
          } else {
            this.showSnackbar("#b71c1c", "Something went wrong!");
          }
        })
        .catch((error) => {
          console.log(error);
          this.showSnackbar("#b71c1c", "Error updating leave.");
        })
        .finally(() => {
          this.loader = false;
        });
    },
    */

    onLoad() {
      this.overlay = true;
      axios
        .post("/Parent/requestLeave")
        .then((res) => {
          this.overlay = false;
          if (res.data.msg === "200") {
            this.childrenList = res.data.childrenList;
            this.leaveApplicationList = res.data.leaveApplicationList;
          }
        })
        .catch((error) => {
          this.overlay = false;
          console.log(error);
        });
    },

    submit() {
      if (this.selected.length === 0) {
        this.showSnackbar("#b71c1c", "Please select at least one child.");
        return;
      }

      this.overlay = true;
      const formData = new FormData();
      formData.append("Start_Date", this.start_date);
      formData.append("End_Date", this.end_date);
      formData.append("leaveReason", this.leaveReason);
      //formData.append("selected", JSON.stringify(this.selected));
      this.selected.forEach(s => formData.append("selected", s));


      if (this.attachment) {
        formData.append("attachment", this.attachment);
      }

      axios
        .post("/Parent/saveLeaveRequest", formData)
        .then((res) => {
          this.overlay = false;
          if (res.data.status === "SUCCESS") {
            this.showSnackbar("#4caf50", "Leave Applied Successfully!");
            this.resetForm();
            this.onLoad();
          } else {
            this.showSnackbar("#b71c1c", res.data.msg || "Leave cannot be applied.");
          }
        })
        .catch((error) => {
          this.overlay = false;
          console.log(error);
        });
    },

    resetForm() {
      this.start_date = "";
      this.end_date = "";
      this.selected = [];
      this.attachment = null;
      this.leaveReason = "";
      this.sdate = new Date().toISOString().substr(0, 10);
      this.edate = new Date().toISOString().substr(0, 10);
    },

    formatDate(date) {
      if (!date) return null;
      const [y, m, d] = date.split("-");
      return `${d}/${m}/${y}`;
    },

    parseDate(date) {
      if (!date) return null;
      const [d, m, y] = date.split("/");
      return `${y}-${m.padStart(2, "0")}-${d.padStart(2, "0")}`;
    },

    select() {
      this.selected = [];
      if (this.selectAll) {
        this.childrenList.forEach((child) => {
          this.selected.push(child.Registration_No);
        });
      }
    },

    showSnackbar(clr, msg) {
      this.snackbar = true;
      this.color = clr;
      this.snackbar_msg = msg;
    }
  }
};
</script>
<style scoped>
.delete-avatar {
  cursor: pointer;
}
.delete-avatar:hover {
  background-color: rgba(255, 0, 0, 0.1);
}

.mytable /deep/ thead th {
  background: #0F2027;
  /* fallback for old browsers */
  background: -webkit-linear-gradient(to right, #2C5364, #203A43, #0F2027);
  /* Chrome 10-25, Safari 5.1-6 */
  background: linear-gradient(to right, #2C5364, #203A43, #0F2027);
  /* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */
  background-color: #0F2027 !important;
  color: white !important;
  font-weight: bold !important;
  white-space: nowrap !important;
  text-align: center;
}

.card-container {
  overflow-x: hidden;
  overflow: hidden;
}
</style>